import React, { Component } from "react";
import * as d3 from "d3";
import "./Dashboard.css";
import math from "mathjs";
import { getText, getLanguage } from '../AllTexts.jsx';

class Dial extends Component {
  constructor(props) {
    super(props);

    this.arcTween = this.arcTween.bind(this);
    this.updateDial = this.updateDial.bind(this);
    this.drawDial = this.drawDial.bind(this);

    this.arc = d3
      .arc()
      .innerRadius(this.props.width / 2 - 30)
      .outerRadius(this.props.width / 2)
      .startAngle(-Math.PI / 2);

    this.scale = d3
      .scaleLinear()
      .range([-Math.PI / 2, Math.PI / 2])
      .domain([0, 100]);
  }

  drawDial() {
    let bg = d3
      .arc()
      .innerRadius(this.props.width / 2 - 15 - 3)
      .outerRadius(this.props.width / 2 - 15 + 3)
      .startAngle(-Math.PI / 2)
      .endAngle(Math.PI / 2);

    d3.select(this.node)
      .append("g")
      .attr(
        "transform",
        "translate(" + this.props.width / 2 + "," + this.props.width / 2 + ")"
      )
      .append("path")
      .style("fill", "white")
      .attr("d", bg);

    d3.select(this.node)
      .append("g")
      .attr(
        "transform",
        "translate(" + this.props.width / 2 + "," + this.props.width / 2 + ")"
      )
      .attr("class", "dial")
      .append("path")
      .datum({ endAngle: this.scale(this.props.value) })
      .style("fill", this.getArcColor())
      .attr("d", this.arc);

    d3.select(this.node)
      .append("g")
      .attr(
        "transform",
        "translate(" + this.props.width / 2 + "," + this.props.width / 2 + ")"
      )
      .append("line")
      .attr("x1", 0)
      .attr("x2", 0)
      .attr("y1", -(this.props.width / 2))
      .attr("y2", -(this.props.width / 2 - 30))
      .style("stroke", "white")
      .style("stroke-width", 6);
  }

  arcTween(newAngle) {
    return d => {
      var interpolate = d3.interpolate(d.endAngle, newAngle);

      return t => {
        d.endAngle = interpolate(t);
        return this.arc(d);
      };
    };
  }

  updateDial() {
    d3.select(this.node)
      .select("g.dial")
      .select("path")
      .transition()
      .duration(1000)
      .ease(d3.easeBounceOut)
      .attrTween("d", this.arcTween(this.scale(this.props.value)))
      .style("fill", this.getArcColor());

    // d3.select(this.node)
    //     .select("g").select("path")
    //     .transition().duration(1000)
    //     .style("fill", d3.interpolateViridis(this.props.value/100));
  }

  getArcColor() {
    if (this.props.noData) {
      return '#bbb';
    } else {
      return d3.interpolateViridis(this.props.value / 110);
    }
  }

  componentDidMount() {
    this.drawDial();
  }

  componentDidUpdate() {
    this.updateDial();
  }

  render() {
    return (
      <svg
        width={this.props.width}
        height={this.props.width / 2}
        ref={node => {
          this.node = node;
        }}
      />
    );
  }
}

class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
  }

  changed() {
    this.props.callback(this.node.current.value);
  }

  render() {
    return (
      <select
        value={this.props.selected}
        style={{
          width: `${8.2 * this.props.values[this.props.selected].length + 50}px`
        }}
        onChange={this.changed.bind(this)}
        ref={this.node}
      >
        {this.props.order.map(k => {
          return (
            <option key={k} value={k}>
              {this.props.values[k]}
            </option>
          );
        })}
      </select>
    );
  }
}

class Row extends Component {
  getAdjectives(v) {
    v = +v;
    if (v < -1) {
      return "much less likely";
    } else if (v < -0.5) {
      return "unlikely";
    } else if (v < 0) {
      return "slightly less likely";
    } else if (v === 0) {
      return "likely as average";
    } else if (v < 0.5) {
      return "slightly more likely";
    } else if (v < 1) {
      return "likely";
    } else {
      return "very likely";
    }
  }

  render() {
    let multiplier = 1;
    if (typeof this.props.property.multiplier !== "undefined") {
      multiplier = this.props.property.multiplier;
    }

    let v;
    
    if (this.props.value === 'NO DATA' || this.props.value === '') {
      v = 50; // when there is no data, we render a grey arc at 50%
    } else {
      v = 50 * (1 + math.erf((this.props.value * multiplier) / Math.sqrt(2)));
    }

    let row = (
      <div className={"dialtext" + (this.props.flip ? " flip" : "")}>
        {`${getText("I am ")}${getText(this.getAdjectives(this.props.value * multiplier))} ${getText(this.props.property.property)}.`}
      </div>
    );

    if (this.props.value === 'NO DATA' || this.props.value === '') {
      row = (
        <div className={"dialtext" + (this.props.flip ? " flip" : "")}>{getText('Not enough data for the selected categories.')}</div>
      );
    }

    // if (v == 50) {
    //     row = <div className={"dialtext" + (this.props.flip ? " flip" : "")}>
    //         {"Missing data for " + (this.props.property.missing ? this.props.property.missing : this.props.property.property)}
    //     </div>;
    //     v = 0;
    // }

    let after;
    let before;
    if (this.props.flip) {
      after = row;
    } else {
      before = row;
    }

    return (
      <React.Fragment>
        <div className="dialrow">
          {before}
          <Dial value={v} width={180} noData={this.props.value === 'NO DATA' || this.props.value === ''} />
          {after}
        </div>
      </React.Fragment>
    );
  }
}

const defaultFilters = {
  vancouver: ["99", "99", "99", "99", "99"],
  toronto: ["99", "99", "99", "99", "99"]
};

const canadianKeyOrder = ["Age", "Immig_coh", "Vis_min", "Sex", "Immig_cat"];
const keyOrder = {
  vancouver: canadianKeyOrder,
  toronto: canadianKeyOrder
};

const whoOrder = {
  Immig_coh: [99, 1, 12, 2, 31, 33, 34, 35, 36],
  Vis_min: [99, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  Immig_cat: [99, 1, 2, 3],
  Age: [99, 1, 2, 3, 4, 5],
  Sex: [99, 1, 2]
};

const properties = [
  {
    id: "z_housing",
    property: "to have affordable housing",
    multiplier: -1
  },
  {
    id: "z_income",
    property: "to have at least a moderate income",
    multiplier: -1
  },
  { id: "z_education", property: "to have a university degree" },
  {
    id: "z_language",
    property: "to speak English or French at home",
    multiplier: -1
  },
  { id: "z_employed", property: "to be employed" },
  { id: "z_owner", property: "to own a home" }
];

const getCanadaDisplayTranslation = (sex) => {
  return {
    Age: {
      99: getText("an 18-64 year old"),
      1: getText("an 18-24 year old"),
      2: getText("a 25-34 year old"),
      3: getText("a 35-44 year old"),
      4: getText("a 45-54 year old"),
      5: getText("a 55-64 year old")
    },
    Immig_coh: {
      99: getText("a Canadian resident. (total)", sex),
      12: getText("was born in Canada, with at least one immigrant parent.", sex),
      1: getText("was born in Canada, as were my parents.", sex),
      2: getText("am not a permanent resident.", sex),
      31: getText("immigrated before 1980.", sex),
      32: getText("immigrated between 1980 and 2016. ", sex),
      33: getText("immigrated between 1980 and 1990. ", sex),
      34: getText("immigrated between 1991 and 2000. ", sex),
      35: getText("immigrated between 2001 and 2010. ", sex),
      36: getText("immigrated between 2011 and 2016. ", sex)
    },
    Vis_min: {
      99: getText("unspecified ethnicity (total)", sex),
      1: getText("non-visible minority", sex),
      2: getText("South Asian", sex),
      3: getText("Chinese", sex),
      4: getText("Black", sex),
      5: getText("Filipino", sex),
      6: getText("Latin American", sex),
      7: getText("Arab", sex),
      8: getText("Southeast Asian", sex),
      9: getText("West Asian", sex),
      10: getText("Korean", sex),
      11: getText("Japanese", sex),
      12: getText("other visible minority", sex),
      13: getText("multiple minority", sex)
    },
    Sex: { 99: getText("person"), 1: getText("man"), 2: getText("woman") },
    Immig_cat: {
      99: getText("by any means. (total)", sex),
      1: getText("through family sponsorship.", sex),
      2: getText("as an economic immigrant.", sex),
      3: getText("as a refugee.", sex)
    }
  }
};

export default class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    d3.csv("data/dashboardChart/" + this.props.city + ".csv").then(data => {
      this.setState({ data });
      this.updateSex(props.filters);
    });
  }

  shouldComponentUpdate(newProps, newState) {
    if (newProps.city != this.props.city) {
      d3.csv("data/dashboardChart/" + newProps.city + ".csv").then(data => {
        this.setState({ data });
      });

      return false;
    }

    if (
      Object.keys(
        getCanadaDisplayTranslation(newState.sex)[keyOrder[newProps.city][0]]
      ).indexOf(newProps.filters[0]) < 0
    ) {
      this.updateFilters(defaultFilters[newProps.city]);
      return false;
    }

    // This is a confusing chunk of code. My understanding is that the last filter (newFilters[4])
    // is not applicable when Immig_coh takes on certain values. But the raw data is always indexed
    // using a full set of filter values. So this piece of code sets the newFilters[4] value to 99
    // so that the desired data row is indexed correctly. There's got to be a more readable way to do this,
    // but I'm going to leave it here for now.
    if (
      ["1", "12", "13", "2"].indexOf(newProps.filters[1]) !== -1 &&
      newProps.filters[4] !== "99"
    ) {
      let newfilters = newProps.filters;
      newfilters[4] = "99";
      this.updateFilters(newfilters);
      return false;
    }

    return true;
  }

  updateFilters(filters) {
    this.props.update({ filters });
    this.updateSex(filters);
  }

  updateSex(filters) {
    let sexIsFemale = (filters) => {
      return filters[canadianKeyOrder.indexOf('Sex')] === '2';
    };

    if (sexIsFemale(filters)) {
      this.setState({ sex: 'female' });
    } else {
      this.setState({ sex: 'male' });
    }
  }

  render() {
    if (this.state.data) {
      let toDisplay = this.state.data.filter(d => {
        let satisfies = true;

        for (var i = 0; i < keyOrder[this.props.city].length; i++) {
          satisfies =
            satisfies &&
            this.props.filters[i] === d[keyOrder[this.props.city][i]];
        }
        return satisfies;
      });

      if (toDisplay.length == 0) {
        toDisplay = [{}];
        properties.forEach(p => {
          toDisplay[0][p.id] = 'NO DATA';
        });
      }

      let ageDropdown = (
        <Dropdown
          selected={this.props.filters[0]}
          values={getCanadaDisplayTranslation(this.state.sex).Age}
          order={whoOrder.Age}
          callback={v => {
            let newFilters = [...this.props.filters];
            newFilters[0] = v;
            this.updateFilters(newFilters);
          }}
        />
      );

      let ethnicityDropdown = (
        <Dropdown
          selected={this.props.filters[2]}
          values={getCanadaDisplayTranslation(this.state.sex).Vis_min}
          order={whoOrder.Vis_min}
          callback={v => {
            let newFilters = [...this.props.filters];
            newFilters[2] = v;
            this.updateFilters(newFilters);
          }}
        />
      );

      let sexDropdown = (
        <Dropdown
          selected={this.props.filters[3]}
          values={getCanadaDisplayTranslation(this.state.sex).Sex}
          order={whoOrder.Sex}
          callback={v => {
            let newFilters = [...this.props.filters];
            newFilters[3] = v;
            this.updateFilters(newFilters);
          }}
        />
      );

      let immigrationOriginDropdown = (
        <Dropdown
          selected={this.props.filters[1]}
          values={getCanadaDisplayTranslation(this.state.sex).Immig_coh}
          order={whoOrder.Immig_coh}
          callback={v => {
            let newFilters = [...this.props.filters];
            newFilters[1] = v;
            this.updateFilters(newFilters);
          }}
        />
      );

      let immigrationCategoryDropdown = [];
      // This is also confusing. This particular dropdown should only appear if
      // Immig_coh is not 1, 12, 13, or 2.
      if (["1", "12", "13", "2"].indexOf(this.props.filters[1]) == -1) {
        immigrationCategoryDropdown = (
          <React.Fragment>
            {getText("I was admitted to Canada ")}
            <Dropdown
              selected={this.props.filters[4]}
              values={getCanadaDisplayTranslation(this.state.sex).Immig_cat}
              order={whoOrder.Immig_cat}
              callback={v => {
                let newFilters = [...this.props.filters];
                newFilters[4] = v;
                this.updateFilters(newFilters);
              }}
            />
          </React.Fragment>
        );
      }

      let currentLanuage = getLanguage();
      let selector;
      if (currentLanuage == 'en') {
        selector = (
          <React.Fragment>
          {getText("I am ")}
          {ageDropdown}
          {ethnicityDropdown}
          {sexDropdown}
          {getText(" and ")}
          {immigrationOriginDropdown}
          <br />
          {immigrationCategoryDropdown}
          </React.Fragment>
        );
      } else {
        selector = (
          <React.Fragment>
            {getText("I am ")}
            {sexDropdown}
            {ethnicityDropdown}
            {ageDropdown}
            {getText(" and ")}
            {immigrationOriginDropdown}
            <br />
            {immigrationCategoryDropdown}
          </React.Fragment>
        );
      }

      return (
        <div id="dashboard">
          <div className="who">{selector}</div>
          <div className="what">
            {properties.map((p, i) => {
              let br = [];
              if (i % 2) {
                br = <hr />;
              }

              if (i === properties.length - 1 && i % 2 == 0) {
                br = (
                  <div
                    className="dialrow"
                    style={{ width: "422px", height: "1px" }}
                  />
                );
              }

              return (
                <React.Fragment>
                  <Row
                    property={p}
                    value={toDisplay[0][p.id]}
                    flip={i % 2}
                  />
                  {br}
                </React.Fragment>
              );
            })}
          </div>
        </div>
      );
    } else {
      return <div id="dashboard" />;
    }
  }
}



// WEBPACK FOOTER //
// ./src/Dashboard/Dashboard.jsx